import { useQuery } from '@tanstack/react-query'

import { patientInstance } from '../..'

export function usePatientQuery({
  patientId,
  enabled
}: {
  patientId?: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: ['patient', patientId],
    queryFn: async () => await patientInstance.getPatient(patientId!),
    enabled: !!patientId && enabled
  })
}
